import { render } from "./deposit.vue?vue&type=template&id=c8d3c69a"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=c8d3c69a&lang=css"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__